import { render, staticRenderFns } from "./build_by_oneself.vue?vue&type=template&id=59168b4c&scoped=true&"
import script from "./build_by_oneself.vue?vue&type=script&lang=js&"
export * from "./build_by_oneself.vue?vue&type=script&lang=js&"
import style0 from "./build_by_oneself.vue?vue&type=style&index=0&id=59168b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59168b4c",
  null
  
)

export default component.exports